import React from "react";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

const phoneNumber = "9243742790";
const whatsappMessage = "Hello! I would like to know more about your services.";

const FloatingIcons = () => {
  return (
    <>
      <a
        href={`tel:${phoneNumber}`}
        className="floating-icon call-icon"
        title="Call Us"
      >
        <FaPhoneAlt size={20} />
      </a>

      <a
        href={`https://wa.me/91${phoneNumber}?text=${encodeURIComponent(
          whatsappMessage
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-icon whatsapp-icon"
        title="Chat on WhatsApp"
      >
        <FaWhatsapp size={20} />
      </a>
    </>
  );
};

export default FloatingIcons;
